import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        setMenuOpen(false);
        navigate(path);
    };

    return (
        <header className="header">
            <div className="header-container">
                {/* Logo */}
                <Link to="/" className="logo-link">
                    <img src="/logo.svg" alt="Logo" className="logo" />
                </Link>

                {menuOpen === false && (
                    <Link to="/fast-exchange" className="fast-exchange">
                        Быстрый обмен
                    </Link>
                )}

                {/* Hamburger Icon */}
                <div className="hamburger" onClick={() => setMenuOpen(true)}>
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line-small"></span>
                    <span className="hamburger-line"></span>
                </div>
            </div>

            <div className={`menu-overlay ${menuOpen ? "active" : ""}`}>
                <div className="menu-content">
                    <span className="close-btn" onClick={() => setMenuOpen(false)}>×</span>

                    {menuOpen && (
                        <span
                            className="menu-link"
                            onClick={() => handleNavigation("/fast-exchange")}
                        >
                            Быстрый обмен
                        </span>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;
